import React from 'react';
import PropTypes from 'prop-types';
import {
  FormattedMessage,
  useIntl,
} from 'react-intl';
import { Field } from 'react-final-form';

import {
  Col,
  Loading,
  Row,
  Select,
} from '@folio/stripes/components';

import WrapperForFormElementWithoutLabel from '../wrapper-for-form-element-without-label';
import RowAsFormElement from '../row-as-form-element';

import {
  ASSIGNED_USER_NAME,
  ASSIGNED_USER_ID,
} from '../../../constants';
import {
  getFirstLastUserName,
  handleFormDataChange,
} from '../../../utils';

const getFormattedOptions = (users) => users.map(
  (user) => (
    <option
      key={user.id}
      value={user.id}
    >
      {getFirstLastUserName(user)}
    </option>
  )
);

const SelectTeamMember = ({
  isObjectDataFormat,
  id,
  name,
  teamMembers,
  isTeamMembersLoaded,
  change,
}) => {
  const intl = useIntl();

  if (!isTeamMembersLoaded) {
    return (
      <Row middle="sm">
        <Col sm={3}>
          <Loading />
        </Col>
      </Row>
    );
  }

  if (teamMembers.length) {
    const usersOptions = getFormattedOptions(teamMembers);

    return (
      <Col
        data-test-assign-team-member
        sm={4}
      >
        <Field
          component={Select}
          id={id}
          label={<FormattedMessage id="ui-task-list.task.field.assignUser" />}
          name={name}
          placeholder={intl.formatMessage({ id: 'ui-task-list.task.field.assignUser.placeholder' })}
          type="text"
          onChange={(event) => {
            const value = event.target.value;
            const currentUser = teamMembers.find(user => user.id === value);

            const changeValues = {
              [ASSIGNED_USER_ID]: value,
              [ASSIGNED_USER_NAME]: getFirstLastUserName(currentUser),
            };

            handleFormDataChange(changeValues, isObjectDataFormat, change);
          }}
        >
          {usersOptions}
        </Field>
      </Col>
    );
  } else {
    return (
      <div data-test-assign-team-member-no-users>
        <WrapperForFormElementWithoutLabel>
          <RowAsFormElement>
            <FormattedMessage id="ui-task-list.user.team.noMembers" />
          </RowAsFormElement>
        </WrapperForFormElementWithoutLabel>
      </div>
    );
  }
};

SelectTeamMember.propTypes = {
  change: PropTypes.func.isRequired,
  isTeamMembersLoaded: PropTypes.bool.isRequired,
  id: PropTypes.string,
  isObjectDataFormat: PropTypes.bool,
  name: PropTypes.string,
  teamMembers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    personal: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string.isRequired,
    }).isRequired,
  })),
};

SelectTeamMember.defaultProps = {
  isObjectDataFormat: false,
  id: ASSIGNED_USER_ID,
  name: ASSIGNED_USER_ID,
  teamMembers: [],
};

export default SelectTeamMember;
